import { render, staticRenderFns } from "./LibrarysAudios.vue?vue&type=template&id=3457877f&scoped=true&"
import script from "./LibrarysAudios.vue?vue&type=script&lang=js&"
export * from "./LibrarysAudios.vue?vue&type=script&lang=js&"
import style0 from "./LibrarysAudios.vue?vue&type=style&index=0&id=3457877f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457877f",
  null
  
)

export default component.exports